module.exports = __webpack_public_path__ + "img/asmntproginactive.f1347a7d.svg";